<agr-dialog
  [data]="data"
  (confirm)="prepareConfirm(removeExistingTreatmentsChoice)"
  (cancel)="cancel()"
>
  <p [innerHTML]="data.text"></p>
  @if (data.askForRemoveExistingTreatmentsConfirmation) {
    <mat-radio-group [(ngModel)]="removeExistingTreatmentsChoice" class="spacing--margin-bottom">
      <mat-radio-button [value]="false" class="flex--column">{{
        'copyAdviceKeepExistingTreatments' | translate
      }}</mat-radio-button>
      <mat-radio-button [value]="true" class="flex--column">{{
        'copyAdviceOverwriteExistingTreatments' | translate
      }}</mat-radio-button>
    </mat-radio-group>
  }
</agr-dialog>
